const domain = '/api' // 配置固定域名，本地调试：http://localhost:5000/api，发布线上使用/api

export default {
	domain,
}